import Img from "../Img";

export interface PartnersProps {
    imgs: string[];
}

const Partners = ({ imgs }: PartnersProps) => {
    return (
        <div className="Partners middle py-10">
            <h1 className="Title text-center text-[2.5rem] font-black">
                <span className="BlackText text-black">Our</span>
                &nbsp;
                <span className="BlackText text-gold">partners</span>
            </h1>
            <p className="text-center text-gray-500 mt-2">Who aren't we working with?</p>
            <div className="Images flex  gap-20 items-center no-scrollbar overflow-x-scroll my-14 middle">
                {
                    imgs.map((img: string, i: number) => {
                        return <Img
                        key={`Partner-${i}`}
                            src={img}
                            alt={img}
                            height={120}
                            width={120}
                            className="shrink-0"
                        />
                    })
                }
            </div>
            <p className="text-center text-gray-500">You can be one of them! Contact us for a deal.</p>

        </div>
    )
}

export default Partners